import { useDispatch, useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { useLocation, useNavigate } from 'react-router';
import { getApplications } from '../../store/actions/authActions';
import { setApplicantType, setClientApplicationId, setKsaCorporate, setRejectionMsg } from '../../store/slices/constantSlice';
import { createCorpApplication, generateAuthToken } from '../../store/actions/corporateAction';
import { useEffect } from 'react';
import { getContentKeyAccToLang } from '../../utils/utils';
export default () => {
  const { isArabic, TextWeight, direction } = dynamicfunction();

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { auth_content } = useSelector((state) => state.common);
  const { applications, authLoading, applications_loading } = useSelector((state) => state.auth);
  const { nafath_loading } = useSelector((state) => state.corporate);
  const { is_corporate, is_ksa_corporate } = useSelector((state) => state.constant);
  const { authContent, language } = useSelector((state) => state.content);
  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_open_new_account?.data?.attributes, key, isArabic);
  };

  const user = location.state?.data;

  useEffect(() => {
    dispatch(getApplications());
  }, [language]);

  const handleNewApplication = () => {
    if (is_corporate) {
      dispatch(
        createCorpApplication(user?.clientId, (res) => {
          dispatch(setClientApplicationId(res?.result));
          if (is_ksa_corporate) {
            navigate('/wathq-verification', { state: { data: { clientId: user?.clientId, corpClientApplicationId: user?.corpClientApplicationId, } } });
          } else {
            navigate('/corporate-form');
          }
        }),
      );
    } else {
      navigate('/choose-applicant-type');
    }
  };


  const onPressApplication = (item) => {
    dispatch(setClientApplicationId(item?.applicationId));
    dispatch(setRejectionMsg(item?.rejectionReason ?? null));
    const is_corp = item?.investorTypeId === 2;

    if (is_corp) {
      dispatch(setKsaCorporate(item?.applicantTypeId === 1067));
      if (item?.applicantTypeId?.toString() === '1067' && !item?.isWathaqVerified) {
        navigate('/wathq-verification', { state: { data: user } });
        return;
      }
      navigate('/corporate-form');
    } else {
      dispatch(
        generateAuthToken(item?.applicationId, (data) => {
          window.open(`${process.env.REACT_APP_INDIVISUAL_FORM}/${data?.message}`, '_self');
        }),
      );

      // const type_id = item?.applicantTypeId;
      // const type = type_id === 12 ? 'KSA Resident' : type_id === 11 ? 'KSA National' : type_id === 13 ? 'GCC National' : 'Other National';
      // dispatch(setApplicantType(type));

      // if ((type_id === 12 || type_id === 11) && !item?.isNafathVerified) {
      //   navigate('/choose-applicant-type');
      //   return;
      // }
      // navigate('/individual-form');
    }
  };

  return {
    isArabic,
    TextWeight,
    direction,
    applications,
    authLoading,
    nafath_loading,
    onPressApplication,
    handleNewApplication,
    user,
    applications_loading,
    getContentKey,
  };
};
